import React from 'react';
import {
  deleteCategoriaDePagos,
  getCategoriasDePagos,
  patchCategoriaDePagos,
  postCategoriaDePagos,
} from 'api/recaudacion/categoriasDePagosDeConvenios';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';

// eslint-disable-next-line react/prop-types
const CategoriaDePagos = ({ permission }) => (
  <PlainCRUD
    permission={permission}
    get={getCategoriasDePagos}
    post={postCategoriaDePagos}
    patch={patchCategoriaDePagos}
    delete={deleteCategoriaDePagos}
    title="Categoría de Pagos"
    withoutState
    fields={[
      defaultFields.descripcion,
      {
        name: 'cantidad_maxima_de_parcialidades_o_mensualidades',
        label: 'Cantidad máxima de parcialidades o mensualidades',
        required: true,
      },
    ]}
  />
);
export default CategoriaDePagos;
